export default __webpack_public_path__ + "static/media/Snd_LowerEBases.2680b58c.mp3";